"use strict";

import '../css/style.scss';

const camalize = (str) => str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());

const filter = {

    itemsSolution: [],
    itemsSolutionContainer: null,

    init() {
        const filterParamsContainer = document.querySelector('.filter__parametrs');
        filterParamsContainer.addEventListener('change', (e) => this.onChangeParams.call(this, e))

        this.itemsSolution = [...document.querySelectorAll('.solutions-item')];
        this.itemsSolutionContainer = document.querySelector('.ready-solutions__items');

        this.filterItems();
    },

    onChangeParams(e) {
        const elem = e.target;

        if (elem.classList.contains('parametr__option-checkbox')) {
            this.filterItems();
        }
    }
    ,
    filterItems() {
        const radiosElems = [...document.querySelectorAll('.parametr__option-checkbox')];

        const options = radiosElems.reduce((obj, radio) => {
            const optionKey = camalize(radio.name.replace('TERRACE_', ''));
            if (radio.checked) obj[optionKey] = radio.value;
            return obj
        }, {});

        const itemsSolutionFiltered = this.itemsSolution.filter(item => this.compareOptions(options, {...item.dataset}));

        this.itemsSolutionContainer.innerHTML = '';
        this.itemsSolutionContainer.append(...itemsSolutionFiltered);
    }
    ,

    compareOptions(optionsRadio, optionsItem) {
        console.log(optionsRadio, optionsItem);
        for (const [option, value] of Object.entries(optionsRadio)) {

            if (optionsItem[option] !== value) return false
        }
        return true;
    }
    ,

    run() {
        this.init();
    }
}

window.onload = () => {
    filter.run();
};